import styles from "./Answer.module.scss";
import { useRef } from "react";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type Props = {
  label: string;
  onSelect: () => void;
  selected: boolean;
};
const Answer = ({ label, onSelect, selected }: Props) => {
  const buttonRef = useRef<null | HTMLButtonElement>(null);

  const buttonClassNames = cx(styles.answer__button, {
    answer__selectedButton: selected,
  });

  return (
    <div className={styles.answer}>
      <button
        className={buttonClassNames}
        onClick={onSelect}
        ref={buttonRef}
        type="button"
      >
        {label} {selected}
      </button>
    </div>
  );
};

export default Answer;
